import styled from 'styled-components'
import Colors from '../../constants/colors'
import { BlogThreshold as Threshold } from '../../constants/theme'

export const Preview = styled.a`
  min-height: 230px;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: ${props => props.previewGap || 0}px;
  text-decoration: none;
  color: ${Colors.text};

  @media (max-width: ${Threshold.phone}) {
    min-height: 230px;
    width: 140px;
    margin-right: ${props => props.previewGapPhone || 0}px;
  }

  .photo-wrapper {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    overflow: hidden;
    
    @media (max-width: ${Threshold.phone}) {
      width: 120px;
      height: 120px;
    }
  }
  .photo {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    transition-duration: 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }
  .name {
    margin: 25px 0 0;
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    line-height: 1.78;

    @media (max-width: ${Threshold.phone}) {
      margin-top: 15px;
      font-size: 12.2px;
    }
  }
`
